import React from "react";
import { Link } from "react-router-dom";
import "./header.css";
import logo from "./../assets/logo.png";

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-row">
        <div className="logo">
          <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
            <img src={logo} alt="" />
          </Link>
        </div>
        <div className="tab-cover">
          <div className="tabs">
            <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
              HOME
            </Link>
          </div>
          <div className="tabs">
            <Link
              to={"/about"}
              style={{ textDecoration: "none", color: "#fff" }}
            >
              ABOUT US
            </Link>
          </div>
          <div className="tabs">
            <Link
              to={"/projects"}
              style={{ textDecoration: "none", color: "#fff" }}
            >
              PROJECTS
            </Link>
          </div>
          {/* <div className="tabs">CLIENTS</div> */}
          <div className="tabs">
            <Link
              to={"/contact-us"}
              style={{ textDecoration: "none", color: "#fff" }}
            >
              CONTACT US
            </Link>
          </div>
        </div>
      </div>
      <div className="header-mobile">
        <div className="logo">
          <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
            <img src={logo} alt="" />
          </Link>
        </div>
        <a
          className="icon"
          onClick={() => {
            let x = document.getElementById("myLinks");
            if (x.style.display === "block") {
              x.style.display = "none";
            } else {
              x.style.display = "block";
            }
          }}
          style={{ textDecoration: "none", color: "#fff", height: "90%" }}
        >
          <i
            className="fa fa-bars"
            style={{
              fontSize: "2em",
              marginRight: "10px",
            }}
          ></i>
        </a>
      </div>
      <div id="myLinks">
        <div className="tabs">
          <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
            HOME
          </Link>
        </div>
        <div className="tabs active">
          <Link to={"/about"} style={{ textDecoration: "none", color: "#fff" }}>
            ABOUT US
          </Link>
        </div>
        <div className="tabs">
          <Link
            to={"/projects"}
            style={{ textDecoration: "none", color: "#fff" }}
          >
            PROJECTS
          </Link>
        </div>
        <div className="tabs">
          <Link
            to={"/contact-us"}
            style={{ textDecoration: "none", color: "#fff" }}
          >
            CONTACT US
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
